import React from 'react'
import { Link } from 'react-router-dom'

import './button.css'

function Button({ content, background, routeAction, targetLink, buttonAction }) {
  return (
    <React.Fragment>
        {
            routeAction ? (
                <Link to={routeAction} >
                    <button className={`button ${background === 'transparent' ? 'transparent' : 'main_bg'}`} >
                        {content}
                    </button>
                </Link>
            ) : (
                <button className={`button ${background === 'transparent' ? 'transparent' : 'main_bg'}`} onClick={buttonAction} >
                    {content}
                </button>
            ) && 
            targetLink ? (
                <a href={targetLink} target='_blank' rel='noreferrer'>
                    <button className={`button ${background === 'transparent' ? 'transparent' : 'main_bg'}`}>
                        {content}
                    </button>
                </a>
            ) : (
                <button className={`button ${background === 'transparent' ? 'transparent' : 'main_bg'}`} onClick={buttonAction} >
                    {content}
                </button>
            )
        }
    </React.Fragment>
  )
}

export default Button